module.exports = __webpack_public_path__ + "img/speed_orange.fa83d816.svg";